<template>
  <div  v-bind="$attrs" v-if="this.$slots.trigger" @click.prevent.stop="this.display = !this.display;">
    <slot name="trigger"/>
  </div>
  <component :is="teleport?'Teleport':'div'" to="#app">
    <div class="waffle modal" :class="`${this.display ? 'modal-open' : ''} modal${(this.$attrs.currentURL || 'ignore').replaceAll('/','-')}`">
      <div class="container" :class="{'slide-popup':this.slide, 'popup-start-position':!this.hasMounted || this.slide}">
        <Griddle />
        <div class="row mt-6">
          <div class="col-sm-1 col-md-2 col-lg-3"></div>
          <div class="col modal-dialog w-100 mw-100">
            <div class="modal-content p-2 p-sm-3 p-md-3">
              <div v-if="this.$slots.dismiss" @click.prevent.stop="this.display = false">
                <slot name="dismiss"/>
              </div>
              <div class="p-5 p-sm-5 p-md-6" :class="{'pt-lg-4': this.$slots.dismiss}">
                <slot/>
              </div>
            </div>
          </div>
          <div class="col-sm-1 col-md-2 col-lg-3"></div>
        </div>
      </div>
    </div>
  </component>
</template>
<script>

import Griddle from "@/components/waffle/components/Griddle";
import {Teleport} from "vue";

export default {
  name: 'PopUp',
  components: {Griddle, Teleport},
  inject:['hasMounted', 'updateMounted'],
  props: {
    teleport: {
      default: false
    },
  },
  data: function() {
    return {
      slide:false,
      display: !this.$slots.trigger
    }
  },
  watch:{
    display(newVal){
      if(newVal){
        setTimeout(() => {
          this.slide = true;
        }, 250)
      }else{
        this.slide =false;
      }
    }
  },
  mounted() {
    if(this.display && !this.hasMounted){
      setTimeout(() => {
        this.slide = true;
      }, 250)
    }
  },
  beforeUnmount() {
    this.updateMounted()
  }
}
</script>
<style scoped lang="scss">
.waffle.modal {
  display: none;
  background: #21212155;
  backdrop-filter: blur(3px);

  &.modal-open {
    display: block;
  }

  > .modal-dialog {
    box-shadow: 0 3px 6px #00000029;
  }
}
/*TODO waffle-pop*/
.x.waffle.modal.modal-open ~ .waffle.modal {
  background: inherit;
  backdrop-filter: inherit;
}

.popup-start-position{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top:-100%;
  transition: top .25s ease;
}

.slide-popup{
  top:inherit;
}

</style>